import AriaModal from "react-aria-modal";
import DemoTwo from './Demon'
import CryptoJS from 'crypto-js';
import {enqueueSnackbar} from "notistack"
import close from "./images/close.png"


const React = require('react');

class PhoneForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalActive: true,
      email: "",
      status: "",
      code:"",
      input_hash:"",
      previous:"",
      username: '',
      password: '',
      phone: '7',
    };
    this.close = this.close.bind(this)
    this.activateModal = this.activateModal.bind(this);
    this.deactivateModal = this.deactivateModal.bind(this);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.checkCode = this.checkCode.bind(this);
    this.logIn = this.logIn.bind(this);
  }

  activateModal = () => {
    this.setState({ modalActive: true });
    console.log(this.props);
  };

  deactivateModal = () => {
    this.setState({ modalActive: false });
    this.close();
  };

 close = async () => {
  const SELF_ADDRESS = process.env.REACT_APP_SELF_ADDRESS;
  window.location.href = `/#/settings/`;
  setTimeout(() => {
          window.location.reload();
        }, 500);
}
  async handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
    var response = await fetch(`${API_ADDRESS}drop_psswd/?email=`+this.state.email, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    });
    var response1 = await response.json();

    if (response1.code === "0") {
      this.setState({
        status: "invalid"
      });
      enqueueSnackbar('Не верный номер телефона или email', { variant: 'error' });
    } else {
      var selectedCode = response1['code'].slice(13, 18);
      this.setState({
        status: "valid",
        code: selectedCode
      });
    }
  }

  handleChange = (event) => {
    const {name, value} = event.target;

    if (name === "phone") {
      const digitsOnly = value.replace(/[^\d]/g, '');

      if (digitsOnly.length === 0 || !digitsOnly.startsWith('7')) {
        this.setState({phone: '7'});
        return;
      }

      const limitedDigits = digitsOnly.slice(0, 11);
      this.setState({phone: limitedDigits});
    } else {
      this.setState({
        [name]: value,
      });
    }
  }

  checkCode(){
    if (this.state.code === this.state.input_hash){
      return true;
    }
    return false;
  }

  async logIn() {
  function encode(token1, iv) {
    var tokenPython = atob(token1);
    var symmetricKey = "NswBgv3KOlaaOt8b";
    var key = CryptoJS.enc.Latin1.parse(
      CryptoJS.enc.Latin1.stringify(CryptoJS.SHA256(symmetricKey))
    );

    // Используем Base64 для iv
    var decrypted = toByteArray(
      CryptoJS.AES.decrypt(
        { ciphertext: CryptoJS.enc.Latin1.parse(tokenPython) },
        key,
        { iv: CryptoJS.enc.Base64.parse(iv), padding: CryptoJS.pad.NoPadding }
      ).toString(CryptoJS.enc.Latin1)
    );

    var answer = decrypted.slice(0, decrypted.length - 1);
    var buffer = new Uint8Array(answer);
    return _arrayBufferToBase64(buffer);
  }

  function _arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  function toByteArray(str) {
    var bArr = [];
    for (var i = 0; i < str.length; i++) {
      bArr.push(str.charCodeAt(i));
    }
    return bArr;
  }

  const phoneWithoutPlus = this.state.phone.replace('+', '');
  const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;

  try {
    const response = await fetch(`${API_ADDRESS}login_user/?email=${this.state.email}&username=${phoneWithoutPlus}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    });

    const data = await response.json();

    if (response.ok && data.token) {
      try {
        var salt = CryptoJS.enc.Base64.parse(data.token.iv);
        var encodedToken = atob(encode(data.token.token, salt.toString(CryptoJS.enc.Base64)));
        localStorage.setItem('token', encodedToken);
        if (data.has_link === true) {
          localStorage.setItem("openModalOnRedirect", "true");
        }
        this.setState({
          logged_in: true,
          modalActive: false,
        });
      } catch (error) {
        console.error("Ошибка при обработке:", error);
        enqueueSnackbar('Ошибка при входе', { variant: 'error' });
      }
    } else {
      enqueueSnackbar('Не удалось войти', { variant: 'error' });
    }
  } catch (err) {
    console.error("Ошибка при авторизации:", err);
    enqueueSnackbar('Ошибка при авторизации', { variant: 'error' });
  }
}

  async componentDidMount() {
  }

  render() {
    const modal = this.state.modalActive
      ? <AriaModal
            titleId="demo-two-title"
            onExit={this.deactivateModal}
            underlayClickExits={false}
            verticallyCenter={true}
        >

          <form onSubmit={this.handleSubmit}>
            <img className="close-bttn img" onClick={this.deactivateModal} height="35x" width="35px" align="right"
                 src={close} alt="close" style={{cursor: 'pointer'}}/>
            <div id="demo-two-modal" className="modal">
              <header className="modal-header">
                <h2 id="demo-two-title" className="modal-title-pass">
                  Введите ваш email и номер телефона. На почту будет отправлен код авторизации.
                </h2>
                <div className="modal-body-code">
                  <div className="centered-input-group">
                    <label htmlFor="input_hash" className="radioText"> Введите номер телефона</label>
                    <input
                        type="text"
                        className="main-input4"
                        name="phone"
                        id="phone"
                        value={this.state.phone}
                        onChange={this.handleChange}
                        style={{marginBottom: '20px'}}
                    />
                    <label htmlFor="input_hash" className="radioText"> Введите email</label>
                    <input type="text" className="main-input4" name="email" id="email" value={this.state.email}
                           onChange={this.handleChange}/>
                  </div>
                </div>
              </header>

              <footer className="modal-footer-code">
                <button type="submit" onClick={() => this.deactivateModal}>
                  Отправить
                </button>
              </footer>
            </div>
          </form>

        </AriaModal>
        : false;
    if (this.state.status==="valid"){
      return (
        <div>
        <DemoTwo callback={this.handleChange} hash={this.checkCode} childOnClick={this.logIn} refresh={this.checkCode} onClick={this.checkCode} isActive={true} closeFunc={this.close}/>
        </div>
      );
    }
    else{
      return (
        <div>
          {modal}
        </div>
      );
    }
  }
}
export default PhoneForm;
